import "./AssetManagerSingleCardWithTabsTemplate.css";

import { ArrowFullLeftDarkIcon } from "../../assets";
import { OrganisationTypeConstants, StandardConstants } from "../../constants";
import { SeedActiveElement, TabsList } from "../../models";
import { Button, Column, OrganisationIcon, Pill, Row, SeedFooter, SeedNavigation, Tabs } from "../../widget";

interface AssetManagerSingleCardWithTabsTemplateProps {
  activeElement?: SeedActiveElement;
  pageTitle: string | undefined;
  tabsList: TabsList;
  backButtonText?: string;
  handleBackClick?: () => void;
  carousel?: JSX.Element | JSX.Element[];
  hasBackground?: boolean;
  quickActions?: JSX.Element;
  titlePill?: string;
  developer?: string;
  developerIcon?: string;
}

export const AssetManagerSingleCardWithTabsTemplate = ({
  activeElement,
  pageTitle,
  tabsList,
  backButtonText,
  handleBackClick,
  carousel,
  hasBackground = true,
  quickActions,
  titlePill,
  developer,
  developerIcon,
}: AssetManagerSingleCardWithTabsTemplateProps): JSX.Element => {
  return (
    <div className="AssetManagerScreen">
      <SeedNavigation activeElement={activeElement} />
      <div className={`AssetManagerSingleCardTemplateContainer ${hasBackground && "HasBackground"}`}>
        {backButtonText && handleBackClick && (
          <Row spacingV="l">
            <Column span={12}>
              <Button
                variant="secondary"
                text={backButtonText}
                icon={<ArrowFullLeftDarkIcon />}
                iconPosition="left"
                onClick={handleBackClick}
              />
            </Column>
          </Row>
        )}
        <Row spacingV="ll">
          <Column span={12} className="Title">
            <div className="TitleContent">
              <h1>{pageTitle}</h1>
              {titlePill && <Pill label={titlePill} variantMap={StandardConstants.CODE_PILL_VARIANT_MAP} />}
            </div>
            {quickActions !== undefined && quickActions}
          </Column>
        </Row>
        {developer && developerIcon && (
          <Row spacingV="ll">
            <Column span={6}>
              <div className="DeveloperInfo">
                <OrganisationIcon organisationIcon={developerIcon} />
                <p className="body1">{developer}</p>
              </div>
            </Column>
          </Row>
        )}
        {carousel && (
          <Row spacingV="ll">
            <Column span={12}>{carousel}</Column>
          </Row>
        )}
        {tabsList.length > 0 && (
          <Tabs
            className="TemplateTabs"
            tabsList={tabsList}
            currentUserType={OrganisationTypeConstants.ASSET_MANAGER}
            variant="tertiary"
          />
        )}
        <SeedFooter />
      </div>
    </div>
  );
};
